
import NativeClient from "@/client/native-client";
import { computed, defineComponent, SetupContext, toRefs } from "vue";

export default defineComponent({
  name: "MyListFolderListItem",
  props: {
    // フォルダID
    folderId: {
      type: Number,
      required: true
    },
    // フォルダ名
    folderTitle: {
      type: String,
      required: true
    },
    // フォルダ画像
    folderImageUrl: {
      type: String
    },
    // フォルダ内のレシピ数
    folderNum: {
      type: Number,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const { folderId } = toRefs(props);
    const { folderTitle } = toRefs(props);

    const folderNumString = computed(() => {
      const result = `${props.folderNum}  `.substr(0, 3);
      NativeClient.sendDebugLog("MyListFolderListItem folderNumString = " + result + ", length = " + result.length);
      return `${props.folderNum}  `.substr(0, 3);
    });
    const folderNumUnit = "menu";
    // ボタンが押されたことを通知する
    const onClick = () => context.emit('on-click', folderId.value, folderTitle.value );

    // // ドラッグ開始
    // const dragStart = () => {
    //   context.emit('start-move');
    // };

    // // ドラッグ終了
    // const dragEnd = () => context.emit('end-move');

    return {
      onClick,
      folderNumString,
      folderNumUnit
    };
  }
});
